import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

const CategoryItemWrapper = styled.a`
  flex: 0 0 auto;
  border-left-style: solid;
  border-left-width: 5px;
  position: relative;
  padding: 0 20px 0 15px;
  display: flex;
  align-items: center;
  font-size: ${props => props.theme.tokens.typography.fontSize.root}px;
  line-height: ${props => props.theme.tokens.fontStack.body1.lineHeight}px;
  text-decoration: none;
  width: 100%;

  @media (max-width: ${props => props.theme.screen_md_max}) {
    padding: 0 15px 0 10px;
  }

  ${props =>
    !props.active &&
    css`
      border-left-color: transparent;
      cursor: pointer;
    `}

  :first-child {
    border-radius: 3px 3px 0 0;
  }

  :last-child {
    border-radius: 0 0 3px 3px;
  }

  ${props =>
    props.isSubHeading &&
    css`
      flex: 0 0 auto;
      margin: 25px 0 0;
      padding: 0 20px;
      width: 100%;
      color: ${props.theme.tokens.color.monochrome.darker};
    `}
`

export const CategoryLink = styled(Link)`
  padding: 20px 0;
  color: ${props => props.theme.tokens.color.monochrome.darker};
  width: 100%;

  ${CategoryItemWrapper}:not(:last-child) & {
    border-bottom: 1px solid ${props => props.theme.tokens.color.monochrome.light};
  }

  :hover {
    color: inherit;
  }
`

export { CategoryItemWrapper }
